// Existing character sheets may use the retired Pages media route or the original R2 domain.
// Keep this helper independent of browser/runtime globals so the Edge Function uses the same mapping.
export function resolveReferenceImageUrl(value: string): string {
    let url: URL;
    try { url = new URL(value); } catch { return value; }
    if (url.protocol !== 'https:' || url.username || url.password || (url.port && url.port !== '443')) return value;
    const legacyR2 = url.hostname === 'pub-f5a158f0e78640529bd030475f5d7491.r2.dev';
    const legacyProxy = ['ezart.ai', 'www.ezart.ai'].includes(url.hostname) && url.pathname.startsWith('/api/media/');
    const bucketPath = url.hostname === 'assets.ezart.ai' && url.pathname.startsWith('/ezart-assets/');
    if (!legacyR2 && !legacyProxy && !bucketPath) return value;
    const asset = new URL('https://assets.ezart.ai');
    let objectPath = legacyProxy ? url.pathname.slice('/api/media'.length) : url.pathname;
    // Public R2 domains already address the bucket; older path-style links included it twice.
    if (objectPath.startsWith('/ezart-assets/')) objectPath = objectPath.slice('/ezart-assets'.length);
    asset.pathname = objectPath;
    asset.search = url.search;
    return asset.href;
}

/** Only studio-owned public assets may be fetched by the authenticated generation server. */
export function isStudioReferenceUrl(value: string): boolean {
    try {
        const url = new URL(resolveReferenceImageUrl(value));
        return url.protocol === 'https:' && url.hostname === 'assets.ezart.ai' &&
            !url.username && !url.password && (!url.port || url.port === '443');
    } catch { return false; }
}
